import { render, staticRenderFns } from "./CompanyAutocompleteInput.vue?vue&type=template&id=252d84ff&scoped=true&"
import script from "./CompanyAutocompleteInput.vue?vue&type=script&lang=ts&"
export * from "./CompanyAutocompleteInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252d84ff",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VListItemAvatar,VListItemContent,VListItemSubtitle,VListItemTitle})
